<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="mb-2 ml-2"
        small
        color="primary"
        dark
        v-bind="attrs"
        v-on="on"
      >
        Import
      </v-btn>
    </template>
    <v-card height="600px">
      <v-card-title>Import Users</v-card-title>
      <v-card-text>
        <VueCsvImport
          :canIgnore="true"
          v-model="csv"
          :map-fields="['firstName', 'lastName', 'email', 'weightedProxy']"
        >
        </VueCsvImport>
      </v-card-text>
      <v-card-actions v-if="csv.length" class="justify-center"
        ><v-btn @click="submit" class="mb-2 ml-2" small color="primary"
          >Import</v-btn
        ></v-card-actions
      >
    </v-card>
  </v-dialog>
</template>
<script>
import client from '@/services/axios';
export default {
  data() {
    return {
      csv: [],
      dialog: false
    };
  },
  methods: {
    async submit() {
      await client.post(
        'users/import/' + this.$store.state.namespace,
        this.csv
      );
      //console.log('response', res);
      this.dialog = false;
      this.$store.commit('SET_MESSAGE', {
        content: 'Users imported sucessfully'
      });
    }
  }
};
</script>
<style>
.vue-csv-uploader .form-group {
  padding: 8px;
}
.vue-csv-uploader .form-group .btn-primary {
  padding: 8px;
  background: grey;
  color: white;
}
.vue-csv-uploader table {
  padding: 5px;
}

.vue-csv-uploader table td {
  padding: 10px;
  font-weight: 600;
}

.vue-csv-uploader select {
  border: solid 1px grey;
  padding: 3px;
}
</style>
